import React, { useMemo } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Task } from '@bringg/types';

import { useStores } from '../../../recipes';
import { AssignModal } from './assign-modal';
import { AssignSelect } from './assign-select';
import { plannedRunsIndicator } from 'bringg-web/stores/runs/planned-runs-indicator';

import './styles.scss';

interface Props {
	taskId: number;
	driverId: number;
	isAllowedToAssignSpecificTask: (task: Task) => boolean;
}

export const AssignDriver = observer(({ taskId, driverId, isAllowedToAssignSpecificTask }: Props) => {
	const { t } = useTranslation();
	const { runStore, alertsStore } = useStores();

	const isPlannedRunsEnabled = useMemo(() => plannedRunsIndicator.isEnabled(), [runStore]);
	const task = alertsStore.getTasks.get(taskId);
	if (!task) {
		return null;
	}

	if (!driverId && !task.team_ids?.length) {
		return <>{t('EXCEPTIONS_LIST.UNASSIGNED')}</>;
	}

	const _isAllowedToAssignSpecificTask = isAllowedToAssignSpecificTask(task);
	return (
		<>
			{isPlannedRunsEnabled ? (
				<AssignModal
					taskId={taskId}
					driverId={driverId}
					isAllowedToAssignSpecificTask={_isAllowedToAssignSpecificTask}
				/>
			) : (
				<AssignSelect
					taskId={taskId}
					driverId={driverId}
					isAllowedToAssignSpecificTask={_isAllowedToAssignSpecificTask}
				/>
			)}
		</>
	);
});
